import './index.css'
import {useState, useEffect, useRef} from 'react'
import carleft from '../../../assets/carleft.svg'
import carright from '../../../assets/carright.svg'
import { useNavigate } from 'react-router-dom'

export const MenuCardDCP = ({data, standby, fungsi}) => {

    const [index, setIndex] = useState(1);
    const firstUpdate = useRef(true);
    const history = useNavigate()

    const [pindah, setPindah] = useState(false)

    useEffect(()=>{
        
        if(pindah===true){
            setTimeout(function() {
                history('/category/chefList/detailChef/detailMenu');
           }, 500);
        }
    },[pindah])

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
          } else {
            var elem = document.getElementById(data.jenis);
            elem.style.transition = "background-image 0.5s";
            elem.style.backgroundImage = `url(${data.food[index-1].gambar})`;
          }
    },[index])

    const handleSelect = (e) => {
        if(e === "left"){
            if(index === 1){
                setIndex(data.food.length)
            }else{
                setIndex(index-1)
            }
        }else{
            if(index === data.food.length){
                setIndex(1)
            }else{
                setIndex(index+1)
            }
        }
    };

    return (
        <div className='DCPmenucard'>
            <div className='DCPkontenmenucard flex'>
                <div id={data.jenis} style={{backgroundImage:`url(${data.food[0].gambar})`}} className='DCPcaraousel'>
                    <img className='DCParrow' onClick={() => handleSelect("left")} style={{marginLeft:"20px",height:"32px", cursor:"pointer"}} alt='icon' src={carleft}></img>
                    <img className='DCParrow' onClick={() => handleSelect("right")} style={{marginLeft:"auto",marginRight:"20px",height:"32px", cursor:"pointer"}} alt='icon' src={carright}></img>
                </div>
                <div onClick={() => {fungsi();setPindah(true)}} className='DCPmenudetail'>
                    <p className='DCPjenismenu'>{data.jenis} Food</p>
                    <p className='DCPcardfoodlist'>
                    {
                        data.food.map((post) => {
                            if(post.nama === data.food[0].nama){
                                return(
                                    <span className='DCPcardfoodlisttext'>{post.nama}</span>
                                )
                            }else{
                                return(
                                    <span className='DCPcardfoodlisttext'>, {post.nama}</span>
                                )
                            }
                        })
                    }
                    </p>
                    <div style={{width:"50%", height:"1px", backgroundColor:"white", marginLeft:"20px", marginTop:"12px"}}></div>
                    <div className='DCPcardkontainerbawah'>
                        <p className='DCPtextmax'> Max {data.max} Guest</p>
                        <p className='DCPtextstart'>Start from</p>
                        <p className='DCPtextharga'>IDR {data.harga}/Pax</p>
                    </div>
                    
                </div>
            </div>
        </div>
    )
  }